import "./bootstrap";
import $ from "jquery";

window.$ = window.jQuery = $;
import * as bootstrap from "bootstrap";
import {tns} from "tiny-slider/src/tiny-slider";

window.tns = tns;
import {entrance} from "scroll-entrance/dist/scroll-entrance";

const Cookies = require("js-cookie");
const lightbox = require("lightbox2");
// import Cropper from "./cropperjs";

import "select2";
import "select2/dist/js/i18n/pl";
import "./script";
import "./contact_form_walid";
import "./walid_modalForm";
import "./walid_modalTestdrive";
import "./walid_modalAccessories";
//import "./walid_marketForm";
import "./visit_service";
import "./modelScript";
import "./history";
import "./calculatorLeasing";
import "./lpg_page";
import "./submit";

import L from "leaflet";
import "leaflet.markercluster";
import {OpenStreetMapProvider, GeoSearchControl} from "leaflet-geosearch";
import Swal from "sweetalert2";

window.OpenStreetMapProvider = OpenStreetMapProvider;
window.GeoSearchControl = GeoSearchControl;

$(document).ready(function () {
    let url = window.location.href;
    const analyticsDataNames = ["utm_source", "utm_medium", "utm_campaign", "gad_source", "gclid"];
    //Cha cha, jakby ktoś używał jednej konwencji, to ta tablica byłaby zbędna
    const analyticsDataCookieNames = ["utmSource", "utmMedium", "utmCampaign", "gadSource", "gclid"];
    let analyticsData = [];

    if (url.includes("?")) {
        let parts = url.split("?");
        let params = parts[1].split("&");

        params.forEach(function (param) {
            let paramName = param.split("=")[0];
            let paramValue = param.split("=")[1];

            if (analyticsDataNames.includes(paramName))
                analyticsData[paramName] = paramValue;
        });

        for (let i=0; i<analyticsDataNames.length; i++)
            document.cookie = analyticsDataCookieNames[i]+"=" + (analyticsData[[analyticsDataNames[i]]] ?? "") + "; path=/";
    }

    $(document).on('click', '.cky-btn-accept, .cky-btn-preferences', function () {
        setTimeout(function () {
            window.location.reload();
        }, 200)
    })
});

